import type { GetSealedOrderDetailResponse } from '@/payment/types'

import { OrderDetailView } from './components'

interface OrderDetailStepProps {
  detail: GetSealedOrderDetailResponse
  onEdit: () => void
  onCancelled: () => void
}

export function OrderDetailStep({ detail, onEdit, onCancelled }: OrderDetailStepProps) {
  return (
    <OrderDetailView
      detail={detail}
      onEdit={onEdit}
      onCancelled={onCancelled}
    />
  )
}
